"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.595 3.214A2.259 2.259 0 0111.859.96a2.26 2.26 0 012.264 2.254v16.707a2.26 2.26 0 01-2.264 2.254 2.26 2.26 0 01-2.264-2.254V3.214zm-4.45 2.784A2.26 2.26 0 002.88 8.252v6.63a2.26 2.26 0 002.264 2.254 2.26 2.26 0 002.264-2.254v-6.63a2.259 2.259 0 00-2.264-2.254zM16.507 9.07v4.995a2.259 2.259 0 002.264 2.254 2.26 2.26 0 002.264-2.254V9.07a2.26 2.26 0 00-2.264-2.254 2.259 2.259 0 00-2.264 2.254z" }), "Services");
//# sourceMappingURL=Services.js.map